import NewsletterForm from './newsletterForm';

export default NewsletterForm;
